import Vue from 'vue'
var bus=new Vue(); //中转站
export default bus;